module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("The Kaiila Will Go Forth for the Hunt")])])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is nearly time. Awaken!\" said Cuwignaka, shaking my shoulder. \"Soon we will be going out.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I rolled over in the robes and opened my eyes. I could see the poles sloping together over my head, the encircling hides. The sky was still almost dark, visible through the smoke hole.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hurry,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I thrust back the robes, and sat up. In the half darkness I saw Cuwignaka pull his dress over his head. He stood up, then, and straightened it on his body, and pulled down the hem. He had, a few days ago, torn away the sleeves. Prior to that, even on the field of battle, weeks ago, he had shortened it, and ripped it at the left thigh, to give himself greater freedom of movement. Males of the red savages, incidentally, commonly sleep naked. I, too, was naked, save that I wore Canka's collar. As a slave I was not permitted to remove it. It must stay on me. Collars are, of course, sometimes removed from slaves. This is often the case, for example, when they are sold or given away. Too, however, they may be removed at other times, for other purposes. It can be done, of course, solely on the decision, and will, of free persons. A given individual may, for example, for one reason or another, not want others to know that a given woman is his slave. Accordingly, she may wear her collar only in his lodge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This is analogous to the secret slaveries which sometimes exist on Earth, where a woman, returning home, kneels and waits to be collared. How startled would be the fellows in the office to discover that that trimly figured, luscious co-worker of theirs, to them seemingly so cool, aloof and inaccessible, is at home another man's slave. Too, how startled would be the women in certain neighborhoods, or in certain organizations and groups, to discover that one of their most popular neighbors, or prominent members, is, in the privacy of her own dwelling, a slave. Alerted by a code word in a seemingly innocent phone call, she prepares herself for her master. She bathes herself and combs herself. She makes herself up. She applies perfume. When he arrives home she is awaiting him, naked, kneeling, on the slave mat, at the foot of his bed, her collar before her. \"Greetings, Master,\" she says. She then lifts the collar in her teeth, that he may put it on her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Wakapapi,\" said Cuwignaka to me. This is the Kaiila word for pemmican. A soft cake of this substance was pressed into my hands. I crumbled it. In the winter, of course, such cakes can be frozen solid. One then breaks them into smaller pieces, warms them in one's hands and mouth, and eats them bit by bit. I lifted the crumbled pemmican to my mouth and ate of it. There are various ways in which pemmican may be prepared, depending primarily on what one adds into the mixture, in the way of herbs, seasonings and fruit. A common way of preparing it is as follows. Strips of kailiauk meat, thinly sliced and dried on poles in the sun, are pounded fine, almost to a powder. Crushed fruit, usually chokecherries, is then added to the meat. The whole, then, is mixed with, and fixed by, kailiauk fat, subsequently, usually, being divided into small, flattish, rounded cakes. The fruit sugars make this, in its way, a quick-energy food, while the meat, of course, supplies valuable, long-lasting stamina protein. This, like the dried meat, or jerky, from which it is made, can be eaten either raw or cooked. It is not uncommon for both to be carried in hunting or on war parties. Children will also carry it in their play. The thin slicing of the meat not only abets its preservation, effected by time, the wind and sun, but makes it impractical for flies to lay their eggs in it. Jerky and pemmican, which is usually eaten cooked in the villages, is generally boiled. In these days a trade pot or kettle is normally used. In the old days it was prepared by stone-boiling. In this technique a hole is used. This hole, dug either within the lodge or outside of it, is lined with hide and filled with water. Fire-heated stones would then be placed in the water, heating it, eventually, to boiling. As the stones cooled, of course, they would be removed from the hide pot and replaced with hot stones, the first stones meanwhile, if needed, being reheated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am going to check the kaiila,\" said Cuwignaka. \"I am going to hitch up the travois.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He wiped his mouth with the back of his forearm. He had been crouching near me, in the half darkness, the white dress marking his position, partaking, too, of the pemmican.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I smiled to myself. Both kaiila, one given to him by his brother, Canka, and the black kaiila, which had been mine, put at my disposal, with the permission of Canka, my master, by my friend, Grunt, the trader, were picketed but a few feet from the threshold of the lodge. Similarly the two travois, fashioned for the morning, were not more than feet away. Cuwignaka was eager.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I sat on the robes, in the half darkness, eating of the pemmican, in Canka's collar.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Outside I could hear the stirrings of the camp. I thought of various slaves I had owned, when I was free, wenches such as Constance, Arlene and Sandra, and Vella and Elicia. They were all hot and looked well in their collars. There was not one there whose lips and tongue, in eager, submissive obedience, a man would not have welcomed on his body. All now knew that on Gor they were naught, and could be naught, but slaves. Too I thought of another woman, olive-skinned, green-eyed, black-haired Talena, once, until disowned, the daughter of Marlenus, the Ubar of Ar. How proud she had been. How she had scorned me when she had thought me helpless! Anger, even in the lodge of Cuwignaka, suffused me. I wondered what she would look like, stripped, in close chains, lying on her side, terrified, at my feet. The common Gorean slave whip has five soft, broad strands. It punishes a woman, terribly. On the other hand it does not mark her. It does not, thus, lower her value.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I sat on the robes, eating the crumbled cake of pemmican. I thought of Talena. Once she had been owned by Rask of Treve. Doubtless he had taught her her slavery well. I thought I might teach it to her better. She lived now, free, but sequestered and dishonored, in the city of Ar, in the Central Cylinder itself, perhaps the most fortified, best-defended tower or keep in that huge city. It would be impossible, or almost so, to even think of extracting her from such a place. No, I must put it from my mind. I recalled her vanity, her arrogance and pride. In the Central Cylinder, if nowhere else, she was surely safe from the bracelets and nooses of marauding tarnsmen. No one, surely, could get at her there. There she was surely safe. I recalled her scorn, her contempt.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("One day, I thought, perhaps, I might try chain-luck in the city of Ar. It is said there are some good-looking women there. I wondered if a place for such a woman might be found in my own holding, say, in my kitchens. Too, of course, I could always give her, as a worthless trinket, one in which I was not personally interested, to one of the lowest and meanest of the taverners of Port Kar. This thought amused me. But I would have to choose the taverner and tavern well. The taverner must be harsh and exacting, petty, avaricious and uncompromising. And his place of business must be one of the worst in the city; it must be in the area of the lower canals; it must be stinking, dingy, squalid and cheap; and it must be busy, crowded often with boisterous ruffians, some just in from the sea, who are impatient with slaves. There, in such a place, let the proud Talena, once the daughter of a Ubar, wear the collar of her master. Let her there, stripped, or silked, as he might choose, serve and please his customers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I chewed the last of the pemmican. Too, I thought I would, before giving her to such a taverner, have her ears pierced. This would, in effect, guarantee that she would remain always only a slave on Gor. Gorean men find pierced ears, as do many men of Earth, stimulatory. To the Gorean such ear-piercing speaks blatantly of bondage. Penetration of a woman's flesh is publicly symbolized, in her very body; the wounds inflicted on her were intended and deliberate; and her body has now been prepared to bear, fastened in its very flesh, barbaric ornamentation. These things all speak to the Gorean of the female slave. In a woman who is truly free such things, of course, would be unthinkable. Many free women, knowing how such things are viewed by Gorean men, fear them more than the brand and collar. Slave girls, of course, once they have begun to learn their collars, and once they have begun to learn that they are truly slaves, and what it might mean, become very vain and proud over the piercing of their ears. They know that it makes them more attractive to men, and significantly so, and, too, they relish being able, with earrings, to make themselves even more beautiful and exciting. Slave girls tend to be very proud and happy in their sexuality. This type of pleasure, commonly denied to the free woman, is probably an additional reason why they tend to hate their helplessly embonded sisters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Are you not ready?\" asked Cuwignaka, coming into the lodge. \"Are you not dressed?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am almost ready,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I reached over and picked up my tunic, and drew it over my head. I then stood up and adjusted it on my body.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Cuwignaka, then, disappeared again through the threshold of the lodge.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Most Gorean males, and their slaves, incidentally, not merely the males of the red savages, commonly sleep naked. If the girl is permitted a sleeping garment it is commonly short, front-opening, and fastened with a single tie. In this way if the master, in the middle of the night, should light a lamp, he may reveal his slave, swiftly and conveniently, to himself. Similarly, even in the darkness, it provides little impedance to his hands or body.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I was thirsty from the pemmican.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Make ready your arrows,\" I heard, a crying from outside the lodge. \"Make ready your arrows! Make ready your knives! We are going to make meat! We are going to make meat!\" This was a crier of the Sleen Soldiers, Agleskala, Striped Lizard. He was moving through the village.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I went to the side of the lodge and felt for the water bag. It was the one which I had once kept on my pack kaiila. Its presence, like that of certain other utensils and articles in the lodge, was due to Grunt. Several other things had been given to Cuwignaka by Canka, or other members of the Isbu, usually of the All Comrades. The lodge itself had been given to him by Akihoka, One-Who-Is-Skillful, an All Comrade, one of Canka's close friends. It is cultural for red savages to look out for one another. Our housekeeping paraphernalia, therefore, though somewhat modest, was adequate. One robe had even been donated by Mahpiyasapa, the civil chief of the Isbu. In doing this he had set an example to his people and, more importantly from Cuwignaka's point of view, acknowledged his right to remain with the Isbu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I heard some kaiila moving past outside. These were probably scouts going out to make contact with the herd guards.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I wondered why the kailiauk were early this year.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I looked about the lodge. It was not untypical. The lodge poles were about twenty-five feet high. They were of tem wood which dries evenly and is long-lasting. The bark is removed from the poles and they are trimmed to an even thickness for most of their length. They are usually about twelve inches around. The top yard or so of their length is tapered, to facilitate their clustering, and being tied in position. In setting up the lodge three or four poles are tied together and raised to a standing position, rather resembling a tripod. The other poles, appropriately spaced, are laid against these. A long rawhide rope, then, from the ground, wound about several times, fastens the primary and secondary poles together. The end of this rope hangs near the lodge entrance, where it may, on a moment's notice, be conveniently utilized. The cover of the lodge consists of several kailiauk hides, sewn together. Depending on the size of the lodge and the size of the hides available, a lodge will usually require in the neighborhood of nineteen or twenty hides. Two long poles, lighter than the lodge poles, are tied to the cover. By means of these lighter poles the cover is put in its place. The two poles hang near the lodge entrance. They are used not only to lift the cover into place, to adjust it, and remove it, but also in the regulation of the flaps at the apex of the lodge, altering or adjusting the smoke hole, in effect, dependent on temperature and wind conditions. Pegs or tent-pins fasten the cover down. In the winter a hide liner may be placed inside the lodge. This will usually have a height of about five feet inside the lodge. A wall of brush, as a snow fence, in effect, may also be used. In the summer the walls of the lodge, as I have mentioned, may be rolled up, transforming it, in effect, into a sun canopy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The outsides of the lodge may be painted, as the occupant pleases. Hunting and war exploits are common themes. The lodge, thus, is a very personal dwelling. Various tribes use different numbers of poles in setting up their lodges. The Fleer usually use twenty, the Sleen twenty-two and the Kaiila twenty-four. Similarly different encampment sites tend to be favored by different tribes. The Kaiila will usually camp near water but in the open, a pasang or so from timber. They seem unusually cognizant of the possibilities of ambush. The Fleer will usually camp in the open but near timber, probably for the convenience of firewood. Yellow Knives often camp in open timber. Sleen, interestingly, often make their camps in thick timber, and even in brush and thickets. What seems to one tribe to present a dangerous possibility of ambush may, to another, seem to provide cover and shelter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Different tribes, too, incidentally, tend to use different moccasin designs. Accordingly, if a track is fresh it is often possible to tell if it was made by a foot wearing, say, a Kaiila or Fleer moccasin. War parties, of course, occasionally utilize this idiosyncrasy, donning moccasins of an enemy pattern when making intrusions into foreign territories. The hides used in the lodges are, of course, translucent. Thus, in the daylight, it is easy to see in the interior. Similarly, at night, one can see shadows within. The lodge at night, interestingly, illuminated from within by its fire, can be a quite lovely sight. This is even more impressive, of course, with a number of lodges.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A camp, at night, incidentally, is usually quite a noisy place. It would not form, for example, an ideal refuge for scholarship. The stereotype of the taciturn red savage is one based, usually, on encountering him in guarded situations, where he is uneasy, perhaps meeting strangers, or is, say, being careful, perhaps being involved in trading. In his villages he is outspoken, good-humored and animate. He likes wagers, practical jokes and telling stories. He is probably one of the world's greatest visitors and, too, one of the world's greatest hosts, one of his great pleasures in life being the giving of gifts and the feasting of friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I drank deeply from the water bag, and then closed it, and replaced it by the lodge wall. The lodge has a diameter of some fifteen feet. This is actually quite spacious. A circular enclosure, of course, geometrically, contains more space, for a given perimeter, than any other figure. Such lodges are conveniently and comfortably inhabited by families of from five to eight red savages. To be sure, much time, most of the year, is spent outdoors. Also, what might seem crowded to one with a particular acculturation may simply seem appropriate and right, even intimate and cozy, to one with a differing acculturation. Family and communal closeness, for better or for worse, are characteristics of the life of the red savage. I do not think he would want it any other way. To be sure, it is not unknown for a man to occasionally seek the lodge of his warrior society, where his children and woman cannot follow him. In his club, so to speak, he might be able to find a bit of peace and quiet which seems to have eluded him at home. Too, of course, meditation, and the seeking of visions and dreams, are solitary activities. A man may indicate that he is meditating by as little as putting his blanket over his head, even in a crowded camp. He will then be left alone. Dreams and visions, on the other hand, are usually sought in the wilderness.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Howo, Tatankasa!\" said Cuwignaka, thrusting his head into the lodge. \"Come on. Come along, Red Bull!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am coming,\" I said. I went outside. It was still quite dark. I could see shapes moving about, however. Cuwignaka had the two travois already hitched up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("There was much movement and excitement in the camp. I wandered off, behind the lodges.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where have you been?\" asked Cuwignaka, when I returned.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where do you think?\" I asked. \"I was relieving myself.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I saw two red savages riding by. They were Sleen Soldiers. One was Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We will be leaving any moment,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I doubt it,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hci turned back his kaiila and brought it to a stop before us. He wore breechclout and moccasins. About his neck was a necklace of sleen claws. His long hair was braided. He carried his bow, not yet strung, and a quiver of arrows, at his left hip. On his belt, that holding the breechclout, there was a knife, in a beaded sheath. Hci's kaiila wore a jaw rope, looped over the back of its neck. This rope, however, is not used, or much used, in either the hunt or war. The rider guides the animal primarily by his knees. His hands, thus, are freed for the use of the bow, or other implements. There was, however, a rope looped about the neck of the kaiila. This rope is thrown to the side and behind the kaiila. If the rider, then, is dismounted in the tumult of the hunt, he may, hopefully, by seizing this rope, sometimes a strap, retain control over his mount and, hastily, safely, regain his seat. Hci's animal, incidentally, was a prize kaiila. This was indicated by its notched ears. The Kaiila notch both ears of such a kaiila. Certain other tribes, such as the Fleer, notch only one ear, usually the left.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Remember, pretty Siptopto,\" said Hci, sneeringly, to Cuwignaka, \"you are not to hunt. You are to remain back from the hunt. It is yours only to cut meat, with the other females.\" 'Siptopto' was an insulting pet name by which Hci occasionally addressed Cuwignaka. It was the sort of name, though not necessarily, that might be given to a female slave. It means \"Beads.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I am not a woman,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You will stay back from the hunt,\" said Hci. \"You will cut meat with the other women.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I will stay back from the hunt,\" said Cuwignaka. \"I will cut meat with the women.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You, and the slave,\" said Hci.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We will stay back from the hunt,\" said Cuwignaka. \"We will cut meat with the women.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Hci then turned his kaiila about, and went, following his fellow rider.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Make ready your arrows!\" I heard again. \"Make ready your arrows! Sharpen your knives! Sharpen your knives! We are going to make meat! We are going to make meat!\" Slowly, through the camp, in the darkness, now crowded with men and women, rode Agleskala, the crier of the Sleen Soldiers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Behind him, in a line, coming from the vicinity of the lodge of the Sleen Soldiers, the society lodge, came several members of the Sleen-Soldiers Society. They were garbed and accoutered much as had been Hci. Two, however, carried long, heavy, stout hunting lances, rather than bows and arrows.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Following them, being careful not to precede them, were some of the first of the hunters.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hou, Witantanka!\" called a girl to one of the warriors. \"Greetings, One-Who-Is-Proud!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hou, Akamda,\" said he to the girl, halting his kaiila. 'Akamda' is a word usually designating fringe, such as might occur on leggings or shirts.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Is a warrior of the Isanna going hunting?\" she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe,\" he said. \"Is a maiden of the Isbu coming out to cut meat?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It is possible,\" she said. \"How many arrows do you have?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Twenty,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Then maybe you will be able to get one beast,\" she said. Hunters pride themselves on making single-arrow kills.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Twenty Pte will let out their water and roll behind me, dying, in the dust,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Cinto!\" she laughed. \"Oh, yes! Surely!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Once my kaiila slipped,\" he said. \"But it was long ago.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you use more than one arrow in any beast,\" she said, \"I will tell everyone.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Would you?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" she said. \"And no more riding after the animal, to pull out the first arrow. You are an idiot. You could have been killed.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I would not do that,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Miniwozan saw you,\" she said. 'Miniwozan' does not translate well. It signifies a mist, or a slowly falling rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Miniwozan, then,\" he said, \"was too close to the herd.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Perhaps,\" granted Akamda.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It was probably another,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It was you,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe I did it,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If you are going to do that sort of thing,\" she said, \"you should wait until the animal is dead, and the herd is passed by.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do you think I could do such a thing?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think maybe you could do it,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not use more than one arrow,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I never use more than one arrow,\" he said, \"almost never.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good hunting,\" she said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If I use more than one arrow, you will not tell anyone, will you?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I will tell you,\" she said, \"you may be assured of that.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"But you will not tell others, will you?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" she said, \"except maybe Miniwozan.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not bother,\" he said. \"I will have it announced by the village crier.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Be careful, Witantanka,\" said the girl.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"In the time of the dancings and the feasts, after the hunting is finished,\" he said, \"I may be looking for a girl to ride with me about the camp.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Behind you, on your kaiila?\" she asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" he said. \"Would you like to ride with me, behind me, on my kaiila, about the camp?\" he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Maybe,\" she said. \"I will think about it.\" This was tantamount to an offer of marriage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think I will go hunting now,\" he said. \"I must take my place.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oglu waste, Witantanka,\" she said. \"Good luck, Witantanka.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Some more hunters drifted past us.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A few yards ahead of where we waited by the lodge there was a group of mounted kaiila riders. There was an older fellow there, a member of the Sleen Soldiers. He was addressing a cluster of some five or six young men, almost boys. It was the first hunt, I gathered, in which they would fully participate, not riding merely at the fringes, observing the older men, but entering among the beasts themselves. I walked up, to where I might hear what was going on. \"Remember,\" the older fellow was telling them, \"you do not hunt for yourself today. You hunt for others. Doubtless there will be hunters who will not be successful today. You will hunt for them. And there are those in the camps who are weak and frail. You will hunt for them. And there are those who are sick, and those who are hurt. For all of these, and others, those less fortunate than yourselves, you hunt today. But always, remember, you hunt not only for yourself. You never hunt only for yourself. You hunt for the Kaiila.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Howe, howe,\" acknowledged the boys.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good hunting,\" said he to them. \"Oglu waste! Good luck!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They then turned their kaiila about, to take their places.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a boy's first hunt he gives his kill, or kills, to others. Only the first beast's tongue, its most prized meat, will he have, it being awarded to him for his efficiency and valor. The purpose of this custom seems to be to encourage the young man, from the very beginning, to think of himself in terms of the gallantry and generosity of the warrior.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("I walked back to where Cuwignaka was waiting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We will soon be going out,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think you are right,\" I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The lodges, incidentally, in a hunt of this sort, are not struck. The Pte, in a herd of this size, moving as slowly as it must, and in virtue of the kaiila and travois, would be within reach for three or four days. The entire encampment of red savages, of course, may be swiftly moved. In less than twenty Ehn an entire camp can be struck, packed and gone. This is a function, of course, of the lodges involved. One woman, working alone, can put one up in fifteen Ehn and strike it in three.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Canka,\" said Cuwignaka, as Canka stopped his kaiila near us.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Greetings, my brother,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Greetings, my brother,\" said Cuwignaka happily. \"What are you going to do this morning?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I think I will go out to look at the Pte,\" said Canka, smiling.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where is Winyela?\" asked Cuwignaka. \"Is she going out? Do you want her to come with us? We will look after her.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"She is going out,\" said Canka. \"But I am sending her out with Wasnapohdi, the slave of Wopeton, the trader. She has been with the hunt before. She will not get too close. She will show her how to cut meat.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Winyela is white,\" said Cuwignaka. \"She will throw up the first time she has to cut meat. She will do it poorly.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If she wastes meat, I will beat her,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You have never beaten her in your life,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"If she wastes meat, I will beat her,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good,\" said Cuwignaka, approvingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I see, little brother,\" said Canka, \"that you, too, are going out.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Of course,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Do not get too close to the herd,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I will not,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This warning on the part of Canka made me somewhat uneasy. I had thought that the dangers in this sort of business were borne primarily, if not exclusively, by the hunters. Yet, of course, it was clear that if the herd, or portions of it, were to veer or circle their movements might bring them into the vicinity of the travois and women. In such a case, of course, one must slash the travois straps, mount up, and make away as best one can. To be sure the greatest dangers were clearly borne by the hunters who must ride among the running beasts themselves, and attempt their kills from a distance just outside the hooking range of the trident, from a distance so close that they might almost reach out and touch the animal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You and Tatankasa will be out there alone,\" said Canka. \"I will not be near you.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I do not understand,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Beware of Hci,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We will,\" said Cuwignaka. The hair on the back of my neck rose up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Have you seen an arrow of mine?\" asked Canka. \"I am missing one of my arrows.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I must have misplaced it,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" said Cuwignaka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I must take my place,\" said Canka.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good hunting. Be careful,\" said Cuwignaka. \"Oglu waste!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Oglu waste,\" said Canka, and then turned his kaiila away, to take his place.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Agleskala now made his third and last circuit of the camp. \"Make ready your arrows,\" he cried. \"Make ready your knives. We are going to make meat! We are going to make meat!\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We are going to make meat!\" cried out several of those about us.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"We are going to make meat!\" said Cuwignaka, happily.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Sleen Soldiers, riding abreast, in a long line, which no hunter, no matter how eager, must cross, in the first streaks of dawn, left the camp. Behind them came the hunters, of the Isbu, of the Casmu, of the Isanna, of the Wismahi, and of the Napoktan, riding five abreast. Dust lifted about the paws of their kaiila. Then came the women, with the kaiila and travois, the poles leaving lines in the dust, and with them, joining them, came Cuwignaka and myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebfc176","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section5.vue
// module id = 78
// module chunks = 0